const SideBarStyles = () => {
    const containerProps = {
        className : "p-10"
    }
    const imageProps = {
        className:"w-90",
        rel:"preload",
        loading:"lazy" ,
    }
    return {containerProps,imageProps}
}

export default SideBarStyles